import type { ContextMenuItem } from "../types/contextMenu.types";
import { ContextMenuActionItem } from "./ContextMenuActionItem";
import { ContextMenuSeparator } from "./ContextMenuSeparator";
import { ContextMenuSubmenuItem } from "./ContextMenuSubmenuItem";

type ContextMenuListProps<TContext> = {
    items: ContextMenuItem<TContext>[];
    context: TContext;
    closeMenu: () => void;
};

export function ContextMenuList<TContext>({
    items,
    context,
    closeMenu,
}: ContextMenuListProps<TContext>) {
    return (
        <div
            role="menu"
            style={{
                minWidth: 220,
                padding: 6,
                borderRadius: 8,
                background: "var(--fx-surface-base, #FFFFFF)",
                boxShadow: "0 12px 32px rgba(0,0,0,0.16)",
                border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.08)",
            }}
        >
            {items.map((item, index) => {
                if (item.type === "separator") {
                    return <ContextMenuSeparator key={item.id ?? `separator-${index}`} />;
                }

                if (item.type === "submenu") {
                    return (
                        <ContextMenuSubmenuItem
                            key={item.id}
                            item={item}
                            context={context}
                            closeMenu={closeMenu}
                        />
                    );
                }

                return (
                    <ContextMenuActionItem
                        key={item.id}
                        item={item}
                        context={context}
                        closeMenu={closeMenu}
                    />
                );
            })}
        </div>
    );
}